module.exports = __webpack_public_path__ + "img/redes-inalambricas-services.c251622d.jpg";